var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',[_c('json-viewer',{attrs:{"value":_vm.parseJson(_vm.value.data),"expand-depth":5,"copyable":"","boxed":"","sort":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }